import type { Answer, Field } from "./types.ts";

export function answerError(field: Field, value: Answer): string | undefined {
  if (value === null && !field.required) return;
  if (
    field.kind === "select" &&
    !(
      typeof value === "string" && field.options?.some((o) => o.value === value)
    )
  )
    return "Choose one of the authored options.";
  if (
    field.kind === "multi" &&
    !(
      Array.isArray(value) &&
      new Set(value).size === value.length &&
      value.every((v) => field.options?.some((o) => o.value === v))
    )
  )
    return "Choose supported options.";
  if (field.kind === "multi" && Array.isArray(value)) {
    if (
      value.length > 1 &&
      field.options?.some((o) => o.exclusive && value.includes(o.value))
    )
      return "Choose an exclusive option on its own.";
    if (
      (field.min !== undefined && value.length < field.min) ||
      (field.max !== undefined && value.length > field.max)
    )
      return "Choose the authored number of options.";
  }
  if (
    (field.kind === "rating" || field.kind === "count") &&
    !(
      typeof value === "number" &&
      Number.isFinite(value) &&
      value >= field.min! &&
      value <= field.max! &&
      Number.isInteger(value)
    )
  )
    return "Enter a whole number inside this field’s limits.";
  if (
    field.kind === "text" &&
    !(typeof value === "string" && value.length <= 10000)
  )
    return "Enter text of at most 10,000 characters.";
}

/** Number controls retain editable strings locally; accepted answers remain numeric. */
export function draftAnswer(field: Field, value: Answer | undefined): Answer {
  if (field.kind === "count" && typeof value === "string")
    return value.trim() === "" ? null : Number(value);
  return value ?? null;
}
